import {
  Tag,
  Button,
  Tooltip,
  Typography,
  Popconfirm,
  Space,
  Badge,
  Flex,
} from "antd";
import get from "lodash/get";
import { getTemplateTagColor } from "./templates";
import { EditOutlined, DeleteOutlined, CopyOutlined } from "@ant-design/icons";
import { copyToClipboard } from "../../utilities/shift";
import map from "lodash/map";
import find from "lodash/find";

const { Text } = Typography;
// Shift setting part table column
export const partColumns = (template_type, config) => {
  switch (template_type) {
    case 1:
      return partInjectionMouldingColumns(config)
    case 2:
      return partExtrutionColumns(config)
    case 3:
      return partPunchPressColumns(config)
    case 4:
      return partCNCColumns(config)
  }
}
// Shift setting part Injection moulding table column

export const partInjectionMouldingColumns = (config) => {
  return [
    {
      title: "Part",
      dataIndex: ["part", "name"],
      key: "partName",
      width: 100,
      render: (text) => <>{text ? text : "--"}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Cavity",
      dataIndex: ["part", "meta", "cavity"],
      key: "cavityNumber",
      width: 80,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Planned Prdouction",
      dataIndex: ["meta", "planned_production_count"],
      key: "planned_production_count",
      width: 80,
      render: (text) => <>{text ? text : 0}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Rejected Count",
      dataIndex: ["meta", "rejected_count"],
      key: "rejected_count",
      width: 80,
      render: (_, record) => <p>{get(record, "meta.rejected_count") ? get(record, "meta.rejected_count", 0) : 0}</p>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Cycle Time",
      dataIndex: ["part", "meta", "cycle_time"],
      key: "cycle",
      width: 80,
      render: (text) => <>{text ? text : 0}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Shot / Part weight (kgs)",
      dataIndex: ["meta", "shot_weight"],
      key: "shotPartWeight",
      width: 100,
      render: (_, record) => (
        <p>
          {get(record, "meta.shot_weight", "0")}
          {` / ${get(record, "meta.part_weight", "0")}`}
        </p>
      ),
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
  ]
};

export const partExtrutionColumns = (config) => {
  return (
    [
      {
        title: "Part",
        dataIndex: ["part", "name"],
        key: "partName",
        width: 100,
        render: (text) => <>{text ? text : "--"}</>,
        onCell: () => ({
          style: { textAlign: "center" },
        }),
        onHeaderCell: () => ({
          style: { textAlign: "center" },
        }),
      },
      {
        title: "Planned length",
        dataIndex: ["meta", "planned_length"],
        key: "planned_production_length",
        width: 80,
        render: (text) => <>{text ? text : 0}</>,
        onCell: () => ({
          style: { textAlign: "center" },
        }),
        onHeaderCell: () => ({
          style: { textAlign: "center" },
        }),
      },
      {
        title: "Rejected length",
        dataIndex: ["meta", "rejected_length"],
        key: "rejected_length",
        width: 80,
        render: (text) => <>{text ? text : 0}</>,
        onCell: () => ({
          style: { textAlign: "center" },
        }),
        onHeaderCell: () => ({
          style: { textAlign: "center" },
        }),
      },
      {
        title: "Part weight (kgs)",
        dataIndex: ["meta", "part_weight"],
        key: "part_weight",
        width: 80,
        render: (text) => <>{text ? text : 0}</>,
        onCell: () => ({
          style: { textAlign: "center" },
        }),
        onHeaderCell: () => ({
          style: { textAlign: "center" },
        }),
      },
      {
        title: "Rejected scrap type",
        dataIndex: ["meta", "rejected_scrap_type"],
        key: "rejected_scrap_type",
        width: 180,
        render: (text) => <>{get(find(get(config, "extrusion_scrap_type"), ['value', text]), 'name') || "--"}</>,
        onCell: () => ({
          style: { textAlign: "center" },
        }),
        onHeaderCell: () => ({
          style: { textAlign: "center" },
        }),
      },
      {
        title: "Process",
        dataIndex: ["meta", "process"],
        key: "process",
        width: 180,
        render: (text) => <>{get(find(get(config, "extrusion_process"), ['value', text]), 'name') || "--"}</>,
        onCell: () => ({
          style: { textAlign: "center" },
        }),
        onHeaderCell: () => ({
          style: { textAlign: "center" },
        }),
      },
    ]
  )
};
export const partPunchPressColumns = (config) => {
  return [
    {
      title: "Part",
      dataIndex: ["part", "name"],
      key: "partName",
      width: 100,
      render: (text) => <>{text ? text : "--"}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Planned prdouction count",
      dataIndex: ["meta", "planned_production_count"],
      key: "planned_production_count",
      width: 80,
      render: (text) => <>{text ? text : 0}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Rejected Count",
      dataIndex: ["meta", "rejected_count"],
      key: "rejected_count",
      width: 80,
      render: (text) => <>{text ? text : 0}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Part weight (kgs)",
      dataIndex: ["meta", "part_weight"],
      key: "part_weight",
      width: 100,
      render: (text) => <>{text ? text : 0}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Press Cycle",
      dataIndex: ["meta", "press_cycle"],
      key: "press_cycle",
      width: 100,
      render: (text) => <>{text ? text : 0}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
  ]
};
export const partCNCColumns = (config) => {
  return [
    {
      title: "Part",
      dataIndex: ["part", "name"],
      key: "partName",
      width: 100,
      render: (text) => <>{text ? text : "--"}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Machining cycle",
      dataIndex: ["meta", "machining_cycle"],
      key: "machining_cycle",
      width: 80,
      render: (text) => <>{text ? text : "--"}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Planned prdouction",
      dataIndex: ["meta", "planned_production"],
      key: "planned_production",
      width: 80,
      render: (text) => <>{text ? text : 0}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Rejected Count",
      dataIndex: ["meta", "rejected_count"],
      key: "rejected_count",
      width: 80,
      render: (_, record) => <p>{get(record, "meta.rejected_count") ? get(record, "meta.rejected_count", 0) : 0}</p>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Raw weight",
      dataIndex: ["meta", "raw_weight"],
      key: "raw_weight",
      width: 80,
      render: (text) => <>{text ? text : 0}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Finished weight (kgs)",
      dataIndex: ["meta", "finished_weight"],
      key: "finished_weight",
      width: 100,
      render: (text) => <>{text ? text : 0}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
  ]
};
// Shift setting production table column

export const productionComponentColumns = (template_type) => {
  switch (template_type) {
    case 1:
      return productionInjectionMouldingColumns
    case 2:
      return productionExtrutionColumns
    case 3:
      return productionPunchPressColumns
    case 4:
      return productionCNCColumns
  }
}

// Shift setting production injection moulding table column
const productionInjectionMouldingColumns = [
  {
    title: "Prod. Component",
    dataIndex: ["component", "name"],
    key: "name",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Start Time",
    dataIndex: "start_time",
    key: "start_time",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "End Time",
    dataIndex: "end_time",
    key: "end_time",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Cycle Time",
    dataIndex: ["meta", "cycle_time"],
    key: "cycle_time",
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Test Shots",
    dataIndex: ["meta", "test_shots"],
    key: "test_shots",
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Planned Down Time",
    dataIndex: ["meta", "planned_down_time"],
    key: "planned_down_time",
    width: 100,
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Job Id",
    dataIndex: "job_id",
    key: "job_id",
    width: 180,
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Batch Number",
    dataIndex: "batch_number",
    key: "batch_number",
    width: 180,
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
]
const productionExtrutionColumns = [
  {
    title: "Prod. Component",
    dataIndex: ["component", "name"],
    key: "name",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Start Time",
    dataIndex: "start_time",
    key: "start_time",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "End Time",
    dataIndex: "end_time",
    key: "end_time",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Test Length",
    dataIndex: ["meta", "test_length"],
    key: "test_length",
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Machine speed",
    dataIndex: ["meta", "machine_speed"],
    key: "speed",
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Planned Down Time",
    dataIndex: ["meta", "planned_down_time"],
    key: "planned_down_time",
    width: 100,
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Job Id",
    dataIndex: "job_id",
    key: "job_id",
    width: 180,
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Batch Number",
    dataIndex: "batch_number",
    key: "batch_number",
    width: 180,
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
]
const productionPunchPressColumns = [
  {
    title: "Prod. Component",
    dataIndex: ["component", "name"],
    key: "name",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    width:200,
  },
  {
    title: "Time",
    dataIndex: "start_time",
    key: "start_time",
    onCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    render: (_, record) => <>{get(record, "start_time", '--')} - {get(record, "end_time", '--')}</>,
    width:200,
  },
  {
    title: "Customer",
    dataIndex: "customer_name",
    key: "operator",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    width:200,
  },
  {
    title: "Operator / Supervisor",
    dataIndex: "operator",
    key: "operator",
    onCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    width:200,
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    render: (_, record) => <p>
      <span className="px-1">
        {get(record, "operator", '--')} &nbsp;
      </span>
      / <span className="px-1">
        {get(record, "supervisor", '--')}
      </span>
    </p>,
  },
  { title: "Manager",
    align:"center",
    dataIndex: ["manager", "name"],
    width:150,
    key: "manager",
    render: (text) => <>{text ? text : '--'}</>,
  },
  {
    title: "Test counts",
    dataIndex: ["meta", "test_counts"],
    key: "test_counts",
    width: 100,
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "Down Time",
    dataIndex: ["meta", "planned_down_time"],
    key: "planned_down_time",
    width: 100,
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "Job Id",
    dataIndex: "job_id",
    key: "job_id",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    fixed:"end",
  },
  {
    title: "Batch Number",
    dataIndex: "batch_number",
    key: "batch_number",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
]
const productionCNCColumns = [
  {
    title: "Prod. Component",
    dataIndex: ["component", "name"],
    key: "name",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Start Time",
    dataIndex: "start_time",
    key: "start_time",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "End Time",
    dataIndex: "end_time",
    key: "end_time",
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Test counts",
    dataIndex: ["meta", "test_counts"],
    key: "test_counts",
    width: 100,
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Cycle time",
    dataIndex: ["meta", "cycle_time"],
    key: "cycle_time",
    width: 100,
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Planned Down Time",
    dataIndex: ["meta", "planned_down_time"],
    key: "planned_down_time",
    width: 100,
    render: (text) => <>{text ? text : 0}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Job Id",
    dataIndex: "job_id",
    key: "job_id",
    width: 180,
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
  {
    title: "Batch Number",
    dataIndex: "batch_number",
    key: "batch_number",
    width: 180,
    render: (text) => <>{text ? text : "--"}</>,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: { textAlign: "center" },
    }),
  },
]
export const shiftColumns = (template, toggle, deleteConfig, filter, isStaff) => {
  return [
    {
      title: "Shift",
      dataIndex: "name",
      key: "shift_name",
      render: (text) => <>{text ? text : "--"}</>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Action",
      key: "action",
      responsive: ["xs", "sm", "md", "lg"],
      render: (record) => (
        <Flex align="center" justify="center">
          <Tooltip title="Edit Config">
            <Button
              type="link"
              onClick={() => {
                toggle({
                  template_uuid: get(template, "id"),
                  template_name: get(template, "name"),
                  ...record,
                });
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
          {get(record, "config.shift_production_components.length") > 0 && (
            <>
              {!isStaff && (
                <Popconfirm
                  title="Delete the Shift Config"
                  description="Are you sure to delete this Shift Config?"
                  onConfirm={() => {
                    deleteConfig(get(record, "config.uuid"));
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Tooltip title="Delete Config">
                    <Button type="link" icon={<DeleteOutlined />}></Button>
                  </Tooltip>
                </Popconfirm>
              )}
              <Tooltip title="Copy Config">
                <Button
                  type="link"
                  onClick={() => {
                    copyToClipboard({
                      ...record,
                      company_uuid: get(filter, "company.id"),
                      templateType: get(template, "type.value")
                    });
                  }}
                  icon={<CopyOutlined />}
                ></Button>
              </Tooltip>
            </>
          )}
        </Flex>
      ),
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
  ];
};

export const overviewColumns = () => {
  return [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Text strong>{text ? text : "--"}</Text>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Type",
      dataIndex: 'type',
      key: "type",
      render: (type) => (
        <Tag color={getTemplateTagColor(get(type, "value"))}>
          <p className="text-center min-w-[120px]">

            {get(type, "name")}
          </p>
        </Tag>
      ),
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Reset time",
      dataIndex: "reset_time",
      key: "reset_time",
      render: (text) => <Text strong>{text ? text : "--"}</Text>,
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Shift Indicator",
      dataIndex: "name",
      render: (_, record) => {
        return (
          <>
            <Space>
              {map(get(record, "shifts"), (shift) => (
                <Tooltip title={get(shift, "name")} style={{ cursor: "pointer" }} key={crypto.randomUUID()}>
                  <Badge
                    size="default"
                    className="custom-badge w-5 h-5 cursor-pointer"
                    status={
                      get(shift, "config.shift_production_components.length")
                        ? "success"
                        : "default"
                    }
                  ></Badge>
                </Tooltip>
              ))}
            </Space>
          </>
        );
      },
      onCell: () => ({
        style: { textAlign: "center" },
      }),
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
  ];
};

export const templateColumns = () => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    responsive: ["xs", "sm", "md", "lg"],
  },

  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    render: (type) => (
      <Tag color={getTemplateTagColor(get(type, "value"))}>
        <p className="text-center min-w-[120px]">

          {get(type, "name")}
        </p>
      </Tag>
    ),
    responsive: ["md", "lg"],
  },
  {
    title: "Reset Time",
    dataIndex: "reset_time",
    key: "reset_time",
    responsive: ["sm", "md", "lg"],
  },
  {
    title: "Last Synced",
    dataIndex: "last_synced",
    key: "last_synced",
    render: (lastSynced) => <Tag>{lastSynced}</Tag>,
    responsive: ["md", "lg"],
  },
];

const getTemplateColumns = (type) => {
  switch (type) {
    case 1:
      return [
        {
          title: "Cavity",
          render: (record) => get(record, "config.meta.cavity", 0),
          key: "cavity",
          width: 50,
          responsive: ["md", "lg"],
        },
        {
          title: "Planned Production",
          render: (record) => get(record, "config.meta.planned_production", 0),
          key: "planned_production",
          width: 100,
          responsive: ["md", "lg"],
        },
        {
          title: "Rejected Count",
          render: (record) => get(record, "config.meta.rejected_count", 0),
          key: "rejected_count",
          width: 100,
          responsive: ["md", "lg"],
        },
        {
          title: "Planned Down Time",
          render: (record) => get(record, "config.meta.planned_down_time", 0),
          key: "planned_down_time",
          width: 100,
          responsive: ["md", "lg"],
        },
        {
          title: "Cycle Time",
          render: (record) => get(record, "config.meta.cycle_time", 0),
          key: "cycle_time",
          width: 100,
          responsive: ["md", "lg"],
        },

        {
          title: "Wages Per Hour",
          render: (record) => get(record, "config.meta.wages_per_hour", 0),
          key: "wages_per_hour",
          width: 100,
          responsive: ["md", "lg"],
        },
        {
          title: "Part / Shot Weight [in gm]",
          render: (record) =>
            `${get(record, "config.meta.part_weight", 0)} / ${get(
              record,
              "config.meta.shot_weight",
              0
            )}`,
          key: "wages_per_hour",
          width: 100,
          responsive: ["md", "lg"],
        },
      ];
  }
};

export const shiftColumn = (template, toggle, deleteConfig, filter) => {
  const templateColumn = getTemplateColumns(get(template, "type.value"));
  return [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      responsive: ["xs", "sm", "md", "lg"],
    },
    {
      title: "Customer",
      key: "customer",
      render: (record) =>
        get(record, "config.customer_name")
          ? get(record, "config.customer_name", "--")
          : "--",
      responsive: ["sm", "md", "lg"],
    },
    {
      title: "Operator",
      key: "operator",
      render: (record) => get(record, "config.operator", "--"),
      responsive: ["md", "lg"],
    },
    {
      title: "Part Number",
      key: "part_number",
      render: (record) => get(record, "config.part", "--"),
      responsive: ["lg"],
    },
    ...templateColumn,
    {
      title: "Action",
      key: "action",
      responsive: ["xs", "sm", "md", "lg"],
      render: (record) => (
        <>
          <Tooltip title="Edit Config">
            <Button
              type="link"
              onClick={() => {
                toggle({
                  template_uuid: get(template, "id"),
                  template_name: get(template, "name"),
                  ...record,
                });
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
          {get(record, "config.part", undefined) && (
            <>
              <Tooltip title="Delete Config">
                <Button
                  type="link"
                  onClick={() => {
                    deleteConfig(get(record, "config.uuid"));
                  }}
                  icon={<DeleteOutlined />}
                ></Button>
              </Tooltip>
              <Tooltip title="Copy Config">
                <Button
                  type="link"
                  onClick={() => {
                    copyToClipboard({
                      ...record,
                      company_uuid: get(filter, "company.id"),
                      templateType: getTemplateColumns(get(template, "type.value"))
                    });
                  }}
                  icon={<CopyOutlined />}
                ></Button>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];
};
